export default "__VITE_ASSET__BbpJTyi5__"